import classNames from 'classnames';
import { observer } from 'mobx-react';

import Link from '../../../shared/components/Link';
import List from '../../../shared/components/List/List';
import { TabState } from '../ConfiguratorTabs/TabState';
import css from './ConfiguratorTabList.css';

interface ConfiguratorTabListProps {
  className?: string;
  items?: TabState[];
  onItemClick?: (nextTab: TabState) => void;
}

const ConfiguratorTabList = ({ className, onItemClick, items }: ConfiguratorTabListProps) => {
  const renderTabItem = (item: TabState) => <ConfiguratorTab state={item} onItemClick={onItemClick} />;

  return (
    <List
      items={items}
      itemRenderer={renderTabItem}
      className={classNames(css.items, className)}
      itemClassName={css.item}
    />
  );
};

export default ConfiguratorTabList;

interface ConfiguratorTabProps {
  state: TabState;
  onItemClick: (tab: TabState) => void;
}

const ConfiguratorTab = observer(({ state, onItemClick }: ConfiguratorTabProps) => {
  return (
    <Link onClick={() => onItemClick(state)} className={classNames(css.link, { [css.linkActive]: state.isActive })}>
      {state.name}
    </Link>
  );
});
